import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import dict from '../dictionary';
import ReducedData from '../reducedData.json';
import {
  labelStyle,
  responsiveFun,
  lineXaxis,
  stroke,
  markers,
} from './options';
import trans from '../translations.json';
import StackedTable from './casesDaily-table';
import { DownloadButton } from './options';
import { ButtonGroup } from './buttonGroup/buttonGroup';
import LegandCheckbox from './legandCheckbox/legandCheckbox';
import { renderToString } from 'react-dom/server';
import {
  ToolTipPercent,
} from './toolTipClone/toolTipClone';
import { dateFormater } from './utils';
const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colors = ['#96b8e9', '#1080A6'];

var cData,
  chartData,
  dailydata,
  averageData = [];

class CasesDaily extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
    chartRef: React.createRef(null),
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };
  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.setData();
    }
  }

  toggle = (name) => {
    this.state.chartRef.current.chart.toggleSeries(name);
    if (this.state.chartRef.current.chart.series.w.globals.noData) {
      this.state.chartRef.current.chart.updateOptions({
        xaxis: {
          labels: {
            show: false,
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          item.options.xaxis = {
            labels: {
              show: false,
            },
          };
          return item;
        }),
      });
    } else {
      this.state.chartRef.current.chart.updateOptions({
        xaxis: {
          labels: {
            show: true,
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          item.options.xaxis = {
            labels: {
              show: true,
            },
          };
          return item;
        }),
      });
    }
  };

  prepData = () => {
    var covidData = ReducedData.covidData;
    cData = [...covidData];
    chartData = cData.filter((item) => item[dict.totaCases] > 0);
    dailydata = chartData
      .map((item, z) => {
        if (chartData[z - 1]) {
          return [
            item[dict.reportedDate],
            item[dict.totaCases] - chartData[z - 1][dict.totaCases],
          ];
        }
      })
      .filter((item) => item !== undefined);

    averageData = chartData.map((item, z) => {
      return [
        item[dict.reportedDate],
        item.Average ? item.Average : 0,
      ];
    });
    averageData.shift();
  };

  prepDataSolgen = () => {
    this.props.data.dataCases.forEach((item) => {
      dailydata.push([item.date, item[dict.NotResolved]]);
    });
  };

  setData = () => {
    if (this.props.data && this.props.data.dataTests) {
      this.prepDataSolgen();
    } else {
      this.prepData();
    }
    this.setState({
      series: [
        {
          name: trans.casesDaily.newcase[this.props.lang],
          data: dailydata,
          type: 'bar',
        },
        {
          name: trans.casesDaily.dayAverage[this.props.lang],
          data: averageData,
          //type: 'line',
        },
      ],

      options: {
        legend: {
          show: false,
        },
        markers: markers,
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },
          custom: function ({ series, dataPointIndex, w }) {
            if (w.globals.collapsedSeriesIndices[0] === 0) {
              const tooltipTitle = () => {
                return dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][0],
                );
              };

              let toolTipData = [
                {
                  label: w.globals.initialSeries[1].name,
                  value:
                    w.globals.initialSeries[1].data[
                      dataPointIndex
                    ][1] +
                    ` (${(
                      (w.globals.initialSeries[1].data[
                        dataPointIndex
                      ][1] /
                        dict.ontarioPop) *
                      100000
                    ).toFixed(2)} cases per 100,000)`,
                  colour: colors[1],
                },
              ];
              return renderToString(
                ToolTipPercent(
                  tooltipTitle(),
                  toolTipData,
                  false,
                  true,
                ),
              );
            } else if (w.globals.collapsedSeriesIndices[0] === 1) {
              const tooltipTitle = () => {
                return dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][0],
                );
              };
              let toolTipData = [
                {
                  label: w.globals.initialSeries[0].name,
                  value:
                    w.globals.initialSeries[0].data[
                      dataPointIndex
                    ][1] +
                    ` (${(
                      (w.globals.initialSeries[0].data[
                        dataPointIndex
                      ][1] /
                        dict.ontarioPop) *
                      100000
                    ).toFixed(2)} cases per 100,000)`,
                  colour: colors[0],
                },
              ];
              return renderToString(
                ToolTipPercent(
                  tooltipTitle(),
                  toolTipData,
                  false,
                  true,
                ),
              );
            } else if (
              w.globals.collapsedSeriesIndices.length === 0
            ) {
              const tooltipTitle = () => {
                return dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][0],
                );
              };
              let toolTipData = [
                {
                  label: w.globals.initialSeries[0].name,
                  value:
                    w.globals.initialSeries[0].data[
                      dataPointIndex
                    ][1] +
                    ` (${(
                      (w.globals.initialSeries[0].data[
                        dataPointIndex
                      ][1] /
                        dict.ontarioPop) *
                      100000
                    ).toFixed(2)} cases per 100,000)`,
                  colour: colors[0],
                },
                {
                  label: w.globals.initialSeries[1].name,
                  value:
                    w.globals.initialSeries[1].data[
                      dataPointIndex
                    ][1] +
                    ` (${(
                      (w.globals.initialSeries[1].data[
                        dataPointIndex
                      ][1] /
                        dict.ontarioPop) *
                      100000
                    ).toFixed(2)} cases per 100,000)`,
                  colour: colors[1],
                },
              ];

              //console.log('toolTipData', toolTipData);
              return renderToString(
                ToolTipPercent(
                  tooltipTitle(),
                  toolTipData,
                  false,
                  true,
                ),
              );
            }
          },
        },
        stroke: stroke,
        dataLabels: {
          enabled: false,
        },
        responsive: responsiveFun().map((item) => {
          item.options.xaxis = { ...lineXaxis(true) };
          item.options.yaxis.title.text =
            trans.casesTotal.yaxis[this.props.lang];
          return item;
        }),
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          //type: 'line',
          zoom: { enabled: true },
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        yaxis: {
          title: {
            text: trans.casesTotal.yaxis[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: { ...lineXaxis(true) },
        colors: this.props.colours || colors,
        //colors: this.props.colours || ['#96b8e9', '#1080A6'],
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <LegandCheckbox
                series={this.state.series}
                colours={colors}
                //colours={['#96b8e9', '#1080A6']}
                toggle={this.toggle}
              />
              <ReactApexChart
                ref={this.state.chartRef}
                options={this.state.options}
                series={this.state.series}
                height="400px"
                aria-hidden="true"
              />
            </>
          );
        case viewModes.table:
          return <StackedTable lang={this.props.lang} />;
        default:
          break;
      }
    };

    return (
      <div id="">
        <p>
          {trans.casesDaily.desc[this.props.lang]}{' '}
          <a href="#time-lag" rel="noopener">
            {trans.heatmap.whyNumbersDontMatch[this.props.lang]}
          </a>
        </p>
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default CasesDaily;
